import { colors } from "react-select/dist/declarations/src/theme"
import { COLOR_OPTION_INTERFACE } from "../pages/Setting/interface"
import { COLOR_OPTION } from "./common"
import { getImageUrl } from "./Funcation"

export const getTheme = (THEME: string) => {
    const theme = COLOR_OPTION.find((_: COLOR_OPTION_INTERFACE) => _.value === THEME)
    return theme
    // COLOR_OPTION
}

/**
 * YIQ formula — returns '#FFF' for dark backgrounds, '#222' for light ones.
 * YIQ = (R*299 + G*587 + B*114) / 1000  →  >= 128 = light bg, < 128 = dark bg
 */
export const hexToYIQTextColor = (hex: string): string => {
    if (!hex) return '#222'
    const clean = hex.replace('#', '')
    const full = clean.length === 3
        ? clean.split('').map(c => c + c).join('')
        : clean
    const r = parseInt(full.substring(0, 2), 16)
    const g = parseInt(full.substring(2, 4), 16)
    const b = parseInt(full.substring(4, 6), 16)
    const yiq = (r * 299 + g * 587 + b * 114) / 1000
    return yiq >= 128 ? '#222' : '#FFF'
}

export const styleObjectGetBG = (theme: string, isBorder: boolean = false, Color:boolean = false) => {
    let obj: any = {
        background: getTheme(theme)?.backgroundColor,
    }
    if (isBorder) {
        // obj.border= `1px solid ${getTheme(theme)?.backgroundColor}`
        obj.border= `1px solid black`
    }
    if (Color) {
        obj.color = getTheme(theme)?.color
    }
    return obj
}
export const styleObjectGetColor = (theme: string,)=>{
    let obj: any = {
        color: getTheme(theme)?.color,
    }
    return obj
}

/**
 * Like styleObjectGetColor but uses YIQ on the menu background color
 * so text is always readable (dark on light bg, white on dark bg).
 */
export const styleObjectGetMenuColor = (theme: string) => {
    const bgColor = getTheme(theme)?.backgroundColor || '#000'
    return {
        color: hexToYIQTextColor(bgColor),
    }
}

export const styleObjectGetActiveMenuBG = (theme: string) => {
    const t = getTheme(theme)
    const bgColor = t?.activeMenuColor || t?.backgroundColor || '#ffff66'
    const obj: any = {
        background: bgColor,
        color: hexToYIQTextColor(bgColor),
    }
    return obj
}

export const styleObjectBlackButton = (theme: string, Hover: boolean, isHide: boolean = false) => {
    let obj = {
        color: Hover ? getTheme(theme)?.color : getTheme(theme)?.backgroundColor,
        // border: `1px solid ${getTheme(theme)?.backgroundColor}`,
        border: isHide ? `1px solid ${getTheme(theme)?.backgroundColor}` : `1px solid black`,
        background: Hover ? getTheme(theme)?.backgroundColor : getTheme(theme)?.color
    }
    return obj
}

export const styleObjectGetLoginImage = (path?: string | null) => {
    const url = getImageUrl(path)
    if (!url) return undefined
    return { backgroundImage: `url("${url.replace(/"/g, "")}")` }
}

export const styleObjectGetBGasColor = (theme: string, borderColor = false) => {
    let obj: any = {
        color: getTheme(theme)?.backgroundColor,
    }
    if (borderColor) {
        obj.borderColor = getTheme(theme)?.backgroundColor;
    }
    return obj
}

const trimLoginCss = (value?: string) =>
    String(value || "").trim().replace(/;+\s*$/, "")

const firstHexFromCss = (value: string) => {
    const match = String(value || "").match(/#([0-9a-fA-F]{3,8})/)
    return match ? `#${match[1]}` : ""
}

/**
 * AG panel header/nav colors from website settings.
 * Blank/unset returns {} so existing CSS / colorSchema stay as-is.
 */
export const getAdminHeaderValue = (headerSchema?: string) => trimLoginCss(headerSchema)

export const getAdminNavValue = (navSchema?: string) => trimLoginCss(navSchema)

export const getAdminAreaTextColor = (bgSchema?: string, textColor?: string) => {
    const customText = trimLoginCss(textColor)
    if (customText) return customText
    const bg = trimLoginCss(bgSchema)
    if (!bg) return ""
    return hexToYIQTextColor(firstHexFromCss(bg) || "#000")
}

export const styleObjectGetAdminHeader = (headerSchema?: string, textColor?: string) => {
    const value = trimLoginCss(headerSchema)
    if (!value) return {}
    const color = getAdminAreaTextColor(headerSchema, textColor)
    return color ? { background: value, color } : { background: value }
}

/** Nav bar background: custom nav color if set, otherwise existing colorSchema. */
export const styleObjectGetAdminNavBG = (navSchema?: string, colorSchema?: string) => {
    const value = trimLoginCss(navSchema)
    console.log({navSchema, colorSchema,})
    if (value) return { background: value, color: colorSchema }
    return styleObjectGetBG(colorSchema || "")
}

/** Nav text: custom/auto when nav color is set, otherwise existing colorSchema. */
export const styleObjectGetAdminNavColor = (
    navSchema?: string,
    textColor?: string,
    colorSchema?: string
) => {
    if (trimLoginCss(navSchema)) {
        return { color: getAdminAreaTextColor(navSchema, textColor) }
    }
    return styleObjectGetMenuColor(colorSchema || "")
}

const normalizeHex = (hex: string) => {
    const clean = hex.replace("#", "").toLowerCase()
    if (clean.length === 3 || clean.length === 4) {
        return clean
            .slice(0, 3)
            .split("")
            .map((c) => c + c)
            .join("")
    }
    return clean.slice(0, 6)
}

/** True when the CSS color is black, including a gradient made only of black. */
export const isBlackCssColor = (value?: string) => {
    const raw = String(value || "").trim().toLowerCase()
    if (!raw) return false
    if (raw === "black") return true

    const hexes = (raw.match(/#[0-9a-f]{3,8}/g) || []).map((token) =>
        normalizeHex(token.slice(1))
    )
    const rgbRe = /rgba?\(\s*(\d+)\s*[, ]\s*(\d+)\s*[, ]\s*(\d+)/g
    const rgbs: string[][] = []
    let rgbMatch: RegExpExecArray | null
    while ((rgbMatch = rgbRe.exec(raw))) {
        rgbs.push([rgbMatch[1], rgbMatch[2], rgbMatch[3]])
    }
    if (!hexes.length && !rgbs.length) return false

    const hexBlack = hexes.every((h) => h === "000000")
    const rgbBlack = rgbs.every((parts) => parts.every((n) => n === "0"))
    return hexBlack && rgbBlack
}

const GRAY_DROPDOWN = {
    background: "#eaeaea",
    color: "#000",
    hoverBackground: "#f5f5f5",
    followNav: false,
}

/**
 * Report dropdown follows the top nav color.
 * Text is picked from that background. A black nav keeps the gray menu.
 */
export const styleObjectGetReportDropdown = (navSchema?: string, colorSchema?: string) => {
    const custom = trimLoginCss(navSchema)
    const bg = custom || getTheme(colorSchema || "")?.backgroundColor || ""
    if (!bg || isBlackCssColor(bg)) return GRAY_DROPDOWN

    const text = hexToYIQTextColor(firstHexFromCss(bg) || "#000000")
    const lightText = hexToYIQTextColor(text) === "#222"
    return {
        background: bg,
        color: text,
        hoverBackground: lightText ? "rgba(255, 255, 255, 0.22)" : "rgba(0, 0, 0, 0.12)",
        followNav: true,
    }
}

/** Active/hover nav item: overlay when custom nav color is set, otherwise existing colorSchema. */
export const styleObjectGetAdminNavActive = (
    navSchema?: string,
    textColor?: string,
    colorSchema?: string
) => {
    // if (trimLoginCss(navSchema)) {
    //     const color = getAdminAreaTextColor(navSchema, textColor)
    //     const isLightText = hexToYIQTextColor(color) === "#222"
    //     return {
    //         background: isLightText ? "rgba(255, 255, 255, 0.22)" : "rgba(0, 0, 0, 0.12)",
    //         color,
    //     }
    // }
    return styleObjectGetActiveMenuBG(colorSchema || "")
}

/** CSS variables for AG mobile login. Blank website fields keep the default login look. */
export const getLoginPageCssVars = (DD: any): Record<string, string> => {
    const pageBg = trimLoginCss(DD?.loginPageBgColor)
    const buttonBg = trimLoginCss(DD?.loginButtonColor)
    const buttonText = trimLoginCss(DD?.loginButtonTextColor)
    const downloadBg = trimLoginCss(DD?.loginDownloadButtonColor)
    const footerLink = trimLoginCss(DD?.loginFooterLinkColor)
    const supportBg = trimLoginCss(DD?.loginSupportColor)

    const vars: Record<string, string> = {}
    if (pageBg) vars["--login-page-bg"] = pageBg
    if (buttonBg) vars["--login-button-bg"] = buttonBg
    if (buttonText) vars["--login-button-text"] = buttonText
    if (downloadBg) vars["--login-download-bg"] = downloadBg
    if (footerLink) vars["--login-footer-link-color"] = footerLink
    if (supportBg) vars["--login-support-bg"] = supportBg
    if (footerLink) vars["--login-skysupport-link"] = footerLink
    const iconOnLight = !supportBg || hexToYIQTextColor(firstHexFromCss(supportBg) || "#ffffff") === "#222"
    vars["--login-support-icon-filter"] = iconOnLight ? "brightness(0)" : "none"
    return vars
}
// export const styleObjectGetBGIMageLoginImage = (path: string) => {
//     let obj = {
//         backgroundImage: `url(${getImageUrl(path)})`
//     }
//     return obj
// }